import { Building2 } from "lucide-react";

const STAT_LABELS = {
  employees: "employees",
  court_cases: "court cases",
  domain_certs: "domain certs",
  gov_awards: "gov awards",
  sanctions: "sanctions",
  press_releases: "press releases",
};

const WikiShareCard = ({ preview }) => {
  const { company_name, stats } = preview || {};
  const nonZero = stats ? Object.entries(stats).filter(([, v]) => v > 0) : [];

  return (
    <div className="space-y-2">
      {company_name && (
        <div className="flex items-center gap-x-2">
          <Building2 className="h-4 w-4 text-mutedText/60" strokeWidth={1.5} />
          <span className="text-[13px] font-light text-mainText">{company_name}</span>
        </div>
      )}
      {nonZero.length > 0 && (
        <div className="flex flex-wrap gap-x-3 gap-y-1 text-[11px] font-light text-mutedText/70">
          {nonZero.map(([key, count]) => (
            <span key={key}>{count} {STAT_LABELS[key] || key}</span>
          ))}
        </div>
      )}
    </div>
  );
};

export default WikiShareCard;
